import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {ActivitiesType} from '../types/ActivitiesType';

export const useGetActivities = () => {
  const [activities, setActivities] = useState<ActivitiesType[]>([]);
  const [activitiesLoading, setActivitiesLoading] = useState<boolean>(false);

  const getActivities = async () => {
    setActivitiesLoading(true);

    try {
      const response = await axios.get(URLS.GET_ACTIVITIES_LOCAL);
      setActivities(response.data.activities);
    } catch (error) {
      console.error(error);
    } finally {
      setActivitiesLoading(false);
    }
  };

  useEffect(() => {
    getActivities();
  }, []);

  return {activitiesLoading, activities};
};
